import { useRouteMatch, useRouter } from '@funtech-int/rival-react';

import { useRuntimeConfig } from '@/shared/hooks/useRuntimeConfig';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

export function useCurrentUrl() {
    const router = useRouter();
    const location = useRouteMatch();
    const searchParams = useSearchParams();
    const runtimeConfig = useRuntimeConfig();

    const url = new URL(router.serialize(location), runtimeConfig.get('host'));

    searchParams.forEach((value, key) => {
        url.searchParams.set(key, value);
    });

    return url;
}
